import { FetcherConfig, PaginatedData } from '@seller-hermes/app/types';
import { User } from '@seller-hermes/features/users/users.types';
import api from '@seller-hermes/utils/api';

export interface UpdateUserPassword {
  email: string;
  new_password: string;
}

interface CreateVenancioDriverUserParam {
  email: string;
  seller_ids: string[];
  internal_driver_document_number: string;
  first_name: string;
  last_name: string;
  phone?: string;
}

export class UsersQuery {
  static search = async (
    body: FetcherConfig
  ): Promise<PaginatedData<User[]>> => {
    return api
      .post('/users-page/v1/search/users', body)
      .then((res) => res.data);
  };

  static updatePassword = async ({
    email,
    new_password,
  }: UpdateUserPassword) => {
    return api
      .patch(`/users/password`, { email, new_password })
      .then((res) => res.data);
  };

  static async sendFeedback(payload: {
    job_title: string;
    stores_managed: string;
    rating: string;
    feedback?: string;
    subscribe: boolean;
    subscribe_email?: string;
  }) {
    return api.post('/user-feedback', payload).then((res) => res.data);
  }
}

export const createVenancioDriverUser = (body: CreateVenancioDriverUserParam) =>
  api.post(`/user-driver-venancio`, body).then((v) => v.data);
